// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { Construction, Fingerprint } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { KeyChip } from "@/components/shared/key-chip";
import { RequirePermission } from "@/components/shared/require-permission";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/sso/$realmId")({
  component: SsoDetailPage,
});

function SsoDetailPage() {
  const { realmId } = Route.useParams();
  const { t } = useTranslation("back-office");
  const breadcrumbs = useMemo(() => [{ label: t("sso.title"), to: "/iam/sso" }], [t]);

  return (
    <RequirePermission permission={PAGE_PERMISSIONS.iamSso}>
      <div>
        <PageHeader
          title={realmId}
          icon={Fingerprint}
          subtitle={<KeyChip label={realmId} />}
          breadcrumbs={breadcrumbs}
        />
        <div className="p-6">
          <div className="flex items-center gap-2 px-4 py-2 rounded-md border border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-400 text-xs">
            <Construction className="h-3.5 w-3.5 shrink-0" />
            {t("activity.wipBanner")}
          </div>
        </div>
      </div>
    </RequirePermission>
  );
}
